import { useState, useEffect } from "react";
import { Phone } from "lucide-react";
import { WhatsAppButton } from "@/components/lunar/WhatsAppButton";
import { Footer } from "@/components/lunar/Footer";
import { Reveal } from "@/components/lunar/Reveal";
import { PillsHeader, VenueHero } from "@/components/venue/VenueHero";
import { Bundles } from "@/components/venue/Bundles";
import { Materials } from "@/components/venue/Materials";
import { RequestForm } from "@/components/venue/RequestForm";

export default function VenueKit() {
    const [pkg, setPkg] = useState("");
    const [intent, setIntent] = useState("kit");
    const [items, setItems] = useState({});
    const [qtys, setQtys] = useState({ Posters: 0, "Tent cards": 0, "Pull-up banners": 0 });
    const [customQty, setCustomQty] = useState({});
    const [posterSize, setPosterSize] = useState("A3");

    useEffect(() => {
        document.title = "Get Lunar at your venue — Lunar";
        return () => {
            document.title = "Lunar — The social network for real life";
        };
    }, []);

    const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

    const choosePackage = (name, nextIntent = "kit") => {
        setPkg(name);
        setIntent(nextIntent);
        scrollTo("request-form");
    };

    return (
        <div data-testid="venue-kit-page">
            <PillsHeader
                links={[
                    { label: "Network", href: "/networking", testId: "pills-header-network" },
                    { label: "Safety →", href: "/safety", testId: "pills-header-safety" },
                ]}
            />
            <main>
                <VenueHero onCta={() => scrollTo("bundles")} />
                <Bundles
                    onRequest={(name) =>
                        choosePackage(name, name === "Bespoke venue bundle" ? "bespoke" : "kit")
                    }
                />
                <Materials
                    items={items}
                    setItems={setItems}
                    qtys={qtys}
                    setQtys={setQtys}
                    customQty={customQty}
                    setCustomQty={setCustomQty}
                    posterSize={posterSize}
                    setPosterSize={setPosterSize}
                    onDone={() => {
                        setIntent("kit");
                        scrollTo("request-form");
                    }}
                />
                <RequestForm pkg={pkg} items={items} intent={intent} />
                <section className="border-t border-[#E5E3DC]" data-testid="venue-final-cta">
                    <Reveal className="mx-auto max-w-3xl px-6 py-20 text-center">
                        <p className="font-display text-2xl font-medium leading-snug text-[#1D201A] sm:text-3xl">
                            Not sure what you need?
                        </p>
                        <p className="mx-auto mt-4 max-w-xl text-base leading-relaxed text-[#5C5F58]">
                            Tell us about your venue, community or development and we’ll help you
                            choose the right materials.
                        </p>
                        <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
                            <a
                                href="tel:+447810014529"
                                data-testid="venue-call-button"
                                className="inline-flex items-center gap-2.5 rounded-full bg-[#2C3618] px-8 py-3.5 text-sm font-bold text-[#F9F8F4] transition-[background-color,transform] duration-300 hover:-translate-y-[2px] hover:bg-[#4A5D23]"
                            >
                                <Phone className="h-4 w-4" strokeWidth={2} />
                                Call us
                            </a>
                            <WhatsAppButton testId="venue-whatsapp-button" />
                            <button
                                data-testid="venue-final-cta-button"
                                onClick={() => choosePackage("", "bespoke")}
                                className="inline-flex items-center rounded-full border border-[#2C3618] px-8 py-3.5 text-sm font-bold text-[#2C3618] transition-[background-color,color,transform] duration-300 hover:-translate-y-[2px] hover:bg-[#2C3618] hover:text-[#F9F8F4]"
                            >
                                Tell us about your venue
                            </button>
                        </div>
                    </Reveal>
                </section>
            </main>
            <Footer showEvents={false} />
        </div>
    );
}
